// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --blue: #1394ff;
  --black: #282828;
  --gray: #e2e4e6;
  --dark-gray: gray;
  --white: #ffffff;
  --light-gray: #d3d3d3;
  --orange: #ff8f00;
  --bg-color: var(--white);
  --header_height: 60px;
  --header_bg_color: var(--black);
  --header_font_color: white;
  --autocomplete_btn_search_bg_color: var(--blue);
  --autocomplete_btn_search_font_color: white;
  --autocomplete_box_height: 40px;
  --theme: var(--blue);
  --rating-bar-color: #3c3b3b;
  --btn-color: var(--black);
  --address_desc_color: #afafaf;
  --address_title_color: #333;
  --address_bg_color: white;
  --fill_color_svg_mobile: #9A9A9A;
  --stroke_color_svg_mobile: white;
}

#alertPopupContainer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 10000;
}

#alertPopup {
  width: calc(100% - 30px);
  max-width: 420px;
  padding: 25px 0 20px;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
}

#alertPopup .header {
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #0c212a;
  margin-bottom: 10px;
  padding: 0 25px;
}

#alertPopup .body {
  font-size: 1rem;
  color: #333333;
  line-height: normal;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  padding: 0 25px;
}

#alertPopup .footer {
  justify-content: center;
  display: flex;
  padding: 18px 25px 0;
  gap: 5px;
}

#alertPopup .btn-ok, #alertPopup .btn-cancel {
  flex: 1;
  max-width: 180px;
  min-width: 0;
  height: 38px;
  font-size: 14px;
  font-family: "Inter", sans-sarif;
  cursor: pointer;
  border-radius: 7px;
}

#alertPopup .btn-ok {
  background-color: var(--theme);
  border: 2px solid var(--theme);
  color: white;
}
#alertPopup .btn-ok:hover {
  background-color: transparent;
  color: var(--theme);
}

#alertPopup .btn-cancel {
  background-color: rgba(var(var(--theme)), 0.5);
  color: var(--theme);
  margin-right: 10px;
}
#alertPopup .btn-cancel:hover {
  background-color: var(--theme);
  color: white;
}

@media (min-width: 768px) {
  #alertPopupContainer {
    position: fixed;
    height: 100%;
  }
  #alertPopup .footer {
    padding: 18px 25px 0;
  }
  #alertPopup .body {
    font-size: 18px;
  }
}
#alertPopup .subTitle {
  font-size: 14px;
  color: #666666;
  margin-top: 10px;
  padding: 0 25px;
  line-height: 1.5;
}

#alertPopup .footerNote {
  font-size: 12px;
  color: #000000;
  padding: 15px 25px 0;
  text-align: left;
  font-weight: 600;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
